import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gr_token", data.token);
      localStorage.setItem("gr_user", JSON.stringify(data.user));
      navigate(data.user.role === "operario" ? "/operario" : "/panel");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 noise-overlay relative">
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center gap-3 justify-center mb-8" data-testid="login-home-link">
          <img src="/logo.webp" alt="GR Soluciones Integrales" className="h-24 w-auto rounded-md bg-white p-2" />
          <span className="font-heading font-bold uppercase tracking-tight text-lg text-white">GR <span className="text-[#F2B90D]">Soluciones Integrales</span></span>
        </Link>
        <form onSubmit={submit} className="bg-[#171717] border border-neutral-800 rounded-md p-8 space-y-5" data-testid="login-form">
          <h1 className="font-heading font-bold uppercase text-xl text-white">Ingresar al panel</h1>
          <div>
            <label className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-400 block mb-2">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@grproducciones.com" className="bg-neutral-900 border-neutral-800 rounded-sm h-11 text-white" data-testid="login-email-input" />
          </div>
          <div>
            <label className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-400 block mb-2">Contraseña</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="bg-neutral-900 border-neutral-800 rounded-sm h-11 text-white" data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#F2B90D] hover:bg-[#DFA90C] text-black rounded-sm font-heading uppercase tracking-wider h-11" data-testid="login-submit-btn">
            {loading ? "Ingresando..." : "Ingresar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
